export const StoriesSection = {
  extends: 'IconSection',

  Right: {
    Body: {
      display: 'grid',
      gridTemplateColumns: 'repeat(auto-fill, minmax(min(100%, 320px), 1fr))',
      gap: 'B',

      childExtends: 'StoryCard',
      childrenAs: 'state',
      children: (el, s) => {
        let n = el.parent
        while (n && typeof n.items !== 'function') n = n.parent
        if (!n) return []
        return n.items(s) || []
      }
    }
  }
}
